import { objectOf, arrayOf, maybe, recordOf, enumOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { ProductAlertStatus } from "./types";

const isProductAlertStatus = enumOf<ProductAlertStatus>("active", "disabled");

const productAlertNotificationSettingsShape = {
  email: maybe(
    objectOf({
      recipients: arrayOf(string),
    })
  ),
  webhook: maybe(
    objectOf({
      url: string,
      headers: maybe(recordOf(string)),
    })
  ),
};

const productAlertScheduleShape = {
  schedule_type: string,
  schedule_time_seconds: number,
  lookback_seconds: number,
  schedule_anchor_seconds: maybe(number),
};

const productAlertResultItemBaseShape = {
  id: string,
  target: string,
  target_id: string,
  target_name: string,
  name: string,
  status: isProductAlertStatus,
  rules: objectOf({
    group_operator: string,
    condition_groups: arrayOf(
      objectOf({
        condition_operator: string,
        conditions: arrayOf(
          objectOf({
            metric: string,
            subject: string,
            operator: string,
            threshold_value: number,
          })
        ),
      })
    ),
  }),
  schedule: objectOf(productAlertScheduleShape),
  notification_channels: arrayOf(string),
  updated_at: number,
};

const productAlertNotificationSettingsValidator = objectOf(productAlertNotificationSettingsShape);

export const isProductAlertResultItem = objectOf({
  ...productAlertResultItemBaseShape,
  notification_settings: productAlertNotificationSettingsValidator,
});

export const isProductAlertsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      ...productAlertResultItemBaseShape,
      notification_settings: maybe(productAlertNotificationSettingsValidator),
    })
  ),
});
